export enum RouteTypeEnum {
  private = 'private', // status auth = true
  public = 'public',
  session = 'session', // authentication route (login, registration, etc.)
}
